import type {ComponentPropertiesContext} from './ComponentPropertiesContext'

/**
 * The empty properties context.
 */
export const emptyPropertiesContext: ComponentPropertiesContext = {}
